import { jsx as _jsx } from "react/jsx-runtime";
const variantClasses = {
    primary: 'bg-accent text-fg-on-accent border border-transparent',
    secondary: 'bg-surface text-fg-primary border border-border-default hover:bg-[rgba(8,15,12,0.3)]',
    danger: 'bg-danger text-fg-on-accent border border-transparent',
    ghost: 'bg-transparent text-fg-primary border border-border-default hover:bg-[rgba(34,197,94,0.05)]',
};
const sizeClasses = {
    sm: 'min-h-9 px-3 text-sm',
    md: 'min-h-11 px-4 text-[0.95rem]',
    lg: 'min-h-14 px-5 text-base',
};
export function Button({ children, variant = 'primary', size = 'md', loading = false, disabled, className = '', style, ...props }) {
    const isDisabled = Boolean(disabled || loading);
    return (_jsx("button", { ...props, disabled: isDisabled, className: `inline-flex items-center justify-center gap-2 rounded-md font-semibold transition-all duration-150 ease-in-out ${isDisabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`, style: style, children: loading ? 'Loading...' : children }));
}
//# sourceMappingURL=Button.js.map